module.exports = __webpack_public_path__ + "img/mgm-h5-clean.ee38b1c3.png";